import {
	BasicCursorName,
	BrushCursor,
	BrushCursorName,
	HealingCursorName,
} from "@/core/utils/brushing"
import { atom } from "jotai"
import { atomWithStorage } from "jotai/utils"
import { safeJSONLocalStorage } from "@/utils/safe-jotai-storage"

export const cursorAtom = atom(
	(get) => {
		const name = get(currentCursorPresetNameAtom)
		const preset =
			name === "healing"
				? get(healingCursorPresetsAtom)["healing"]
				: get(cursorPresetsAtom)[name]

		if (!preset) {
			throw new Error(`No cursor preset named ${name}`)
		}

		if (!preset.x || !preset.y) {
			preset.x = 0.5
			preset.y = 0.5
		}

		return preset
	},
	(get, set, newCursor: BrushCursor) => {
		if (newCursor.name === "healing") {
			const presets = get(healingCursorPresetsAtom)

			for (const name in presets) {
				presets[name].x = newCursor.x
				presets[name].y = newCursor.y
			}

			set(healingCursorPresetsAtom, {
				...presets,
				[newCursor.name]: newCursor,
			})
		} else {
			const presets = get(cursorPresetsAtom)

			for (const name in presets) {
				presets[name].x = newCursor.x
				presets[name].y = newCursor.y
			}

			set(cursorPresetsAtom, {
				...presets,
				[newCursor.name]: newCursor,
			})
		}
	},
)

export const currentCursorPresetNameAtom = atom<BrushCursorName>("brush")

export const cursorPresetsAtom = atomWithStorage<Record<BasicCursorName, BrushCursor>>(
	"brush-cursor-presets",
	{
		brush: {
			name: "brush",
			x: 0.5,
			y: 0.5,
			feather: 0.2,
			radius: 0.15,
			flow: 1.0,
			density: 1.0,
			isErasing: false,
			isColorAware: true,
		},
		erase: {
			name: "erase",
			x: 0.5,
			y: 0.5,
			feather: 0.2,
			radius: 0.2,
			flow: 1.0,
			density: 1.0,
			isErasing: true,
			isColorAware: false,
		},
	},
	safeJSONLocalStorage<Record<BasicCursorName, BrushCursor>>(),
)

export const healingCursorPresetsAtom = atomWithStorage<Record<HealingCursorName, BrushCursor>>(
	"healing-brush-cursor-presets",
	{
		healing: {
			name: "healing",
			x: 0.5,
			y: 0.5,
			feather: 0.0,
			radius: 0.125,
			flow: 1.0,
			density: 1.0,
			isErasing: false,
			isColorAware: false,
		},
	},
	safeJSONLocalStorage<Record<HealingCursorName, BrushCursor>>(),
)
